var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoThumbnail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50939e-05 6.91503C-0.00250271 6.33648 0.310135 5.80243 0.815858 5.52141L9.52612 0.681275C10.2293 0.290542 11.0939 0.796728 11.0974 1.60115L11.1066 3.70252C11.1091 4.28108 10.7965 4.81512 10.2907 5.09614L1.58049 9.93628C0.877325 10.327 0.0126609 9.82083 0.00916012 9.01641L1.50939e-05 6.91503Z",
    fill: "url(#paint0_linear_15194_365015)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89305 16.2974C4.89053 15.7188 5.20317 15.1848 5.70889 14.9038L14.4192 10.0636C15.1223 9.67289 15.987 10.1791 15.9905 10.9835L15.9996 13.0849C16.0021 13.6634 15.6895 14.1975 15.1838 14.4785L6.47352 19.3186C5.77036 19.7094 4.9057 19.2032 4.9022 18.3988L4.89305 16.2974Z",
    fill: "url(#paint1_linear_15194_365015)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6987 6.30108C12.0454 5.89083 11.2206 5.86873 10.5463 6.24343L2.10938 10.9317C1.40622 11.3224 1.37939 12.324 2.06063 12.7518L3.57541 13.7031C4.22868 14.1134 5.05349 14.1355 5.72779 13.7608L14.1647 9.0725C14.8679 8.68177 14.8947 7.6802 14.2135 7.25238L12.6987 6.30108Z",
    fill: "url(#paint2_linear_15194_365015)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15194_365015",
    x1: 3.00411,
    y1: 14.0726,
    x2: 12.6401,
    y2: 6.92172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0072DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#009DF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5AC3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15194_365015",
    x1: 3.00411,
    y1: 14.0726,
    x2: 12.6401,
    y2: 6.92172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0072DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#009DF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5AC3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15194_365015",
    x1: 3.00411,
    y1: 14.0726,
    x2: 12.6401,
    y2: 6.92172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0072DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#009DF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5AC3FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoThumbnail);
export default __webpack_public_path__ + "static/media/logo-thumbnail.4fbdb48ea71b33fad93026436bcb77cc.svg";
export { ForwardRef as ReactComponent };